<template>
  <div class="time-number">
    {{ number }}
  </div>
</template>

<script>
export default {
  name: 'TimeNumber',
  props: {
    number: String | Number
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
.time-number {
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/TimeNumber.vue